// router.js
import Vue from 'vue';
import Router from 'vue-router';
import VueAnalytics from 'vue-analytics'
const Homepage = () => import(/* webpackChunkName: "Home" */'../components/Homepage.vue');

const UsProduct = () => import(/* webpackChunkName: "GbProduct" */'../components/us/Product.vue');
const UsOptionsX5 = () => import(/* webpackChunkName: "GbOptionsSimFree" */'../components/us/OptionsX5.vue');

const GbProduct = () => import(/* webpackChunkName: "GbProduct" */'../components/gb/Product.vue');
const GbOptionsXGO2 = () => import(/* webpackChunkName: "GbOptionsSimFree" */'../components/gb/OptionsXGO2.vue');
const GbOptionsX5 = () => import(/* webpackChunkName: "GbOptionsSimFree" */'../components/gb/OptionsX5.vue');
const GbOptionsX4 = () => import(/* webpackChunkName: "GbOptionsSimFree" */'../components/gb/OptionsX4.vue');
const GbOptionsGoSimFree = () => import(/* webpackChunkName: "GbOptionsSimFree" */'../components/gb/OptionsGoSimFree.vue');
const GbOptions3SSimFree = () => import(/* webpackChunkName: "GbOptionsSimFree" */'../components/gb/Options3SSimFree.vue');
const GbOptionsSimFree = () => import(/* webpackChunkName: "GbOptionsSimFree" */'../components/gb/OptionsSimFree.vue');
const GbOptionsSimIncluded = () => import(/* webpackChunkName: "GbOptionsSimIncluded" */'../components/gb/OptionsSimIncluded.vue');
const GbTechnicalSpecifications = () => import(/* webpackChunkName: "GbTechnicalSpecifications" */'../components/gb/TechnicalSpecifications.vue');

const DeProduct = () => import(/* webpackChunkName: "DeProduct" */'../components/de/Product.vue');
const DeOptionsSimFree = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/OptionsSimFree.vue');
const DeOptionsSimIncluded = () => import(/* webpackChunkName: "DeOptionsSimIncluded" */'../components/de/OptionsSimIncluded.vue');
const DeOptions3SSimFree = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/Options3SSimFree.vue');
const DeOptions3SimFree = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/Options3SimFree.vue');
const DeOptionsGoSimFree = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/OptionsGoSimFree.vue');
const DeOptionsX4 = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/OptionsX4.vue');
const DeOptionsX5 = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/OptionsX5.vue');
const DeOptionsXGO2 = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/OptionsXGO2.vue');
const DeOptionsActivityBand = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/de/OptionsActivityBand.vue'); 
const DeTechnicalSpecifications = () => import(/* webpackChunkName: "DeTechnicalSpecifications" */'../components/de/TechnicalSpecifications.vue');

const EsProduct = () => import(/* webpackChunkName: "DeProduct" */'../components/es/Product.vue');
const EsOptionsSimFree = () => import(/* webpackChunkName: "EsOptionsSimFree" */'../components/es/OptionsSimFree.vue');
const EsOptions3SSimFree = () => import(/* webpackChunkName: "EsOptionsSimFree" */'../components/es/Options3SSimFree.vue');
const EsOptionsGoSimFree = () => import(/* webpackChunkName: "EsOptionsSimFree" */'../components/es/OptionsGoSimFree.vue');
const EsOptionsX4 = () => import(/* webpackChunkName: "EsOptionsSimFree" */'../components/es/OptionsX4.vue');
const EsOptionsXGO2 = () => import(/* webpackChunkName: "EsOptionsSimFree" */'../components/es/OptionsXGO2.vue');
const EsOptionsX5 = () => import(/* webpackChunkName: "DeOptionsSimFree" */'../components/es/OptionsX5.vue');
const EsTechnicalSpecifications = () => import(/* webpackChunkName: "EsTechnicalSpecifications" */'../components/es/TechnicalSpecifications.vue');

const PlOptionsSimFree = () => import(/* webpackChunkName: "PlOptionsSimFree" */'../components/pl/OptionsSimFree.vue');
const PlTechnicalSpecifications = () => import(/* webpackChunkName: "PlTechnicalSpecifications" */'../components/pl/TechnicalSpecifications.vue');

const FrProduct = () => import(/* webpackChunkName: "FrProduct" */'../components/fr/Product.vue');
const FrOptions3SSimFree = () => import(/* webpackChunkName: "FrOptionsSimFree" */'../components/fr/Options3SSimFree.vue');

const NoProduct = () => import(/* webpackChunkName: "NoProduct" */'../components/no/Product.vue');
const NoOptionsXplora1 = () => import(/* webpackChunkName: "NoOptionsXplora1" */'../components/no/OptionsXplora1.vue');
const NoOptionsXplora2 = () => import(/* webpackChunkName: "NoOptionsXplora2" */'../components/no/OptionsXplora2.vue');
const NoOptionsXplora3S = () => import(/* webpackChunkName: "NoOptionsXplora3S" */'../components/no/OptionsXplora3S.vue');
const NoOptionsXploraGo = () => import(/* webpackChunkName: "NoOptionsXplora3S" */'../components/no/OptionsXploraGo.vue');

const SeProduct = () => import(/* webpackChunkName: "SeProduct" */'../components/se/Product.vue');
const SeOptionsXplora1 = () => import(/* webpackChunkName: "SeOptionsXplora1" */'../components/se/OptionsXplora1.vue');
const SeOptionsXplora2 = () => import(/* webpackChunkName: "SeOptionsXplora2" */'../components/se/OptionsXplora2.vue');
const SeOptionsXplora3S = () => import(/* webpackChunkName: "SeOptionsXplora3S" */'../components/se/OptionsXplora3S.vue');

const HungaryInformation = () => import('../components/hu/Information.vue');

Vue.use(Router);

export function createRouter () {
  var router = new Router({
    mode: 'history',
    routes: [
      	{ 
      		path: '/', 
      		name: 'homepage',
      		component: Homepage 
      	},
        { 
          path: '/gb', 
          name: 'gbProduct',
          component: GbProduct 
        },
        { 
          path: '/gb/sim-free', 
          name: 'gbOptionsSimFree',
          component: GbOptionsSimFree 
        },
        { 
          path: '/gb/x4', 
          name: 'gbOptionsX4',
          component: GbOptionsX4 
        },
        { 
          path: '/gb/x5', 
          name: 'gbOptionsX5',
          component: GbOptionsX5
        },
        { 
          path: '/gb/xgo2', 
          name: 'gbOptionsXGO2',
          component: GbOptionsXGO2
        },
        { 
          path: '/gb/go-sim-free', 
          name: 'gbOptionsGoSimFree',
          component: GbOptionsGoSimFree 
        },
        { 
          path: '/gb/3s-sim-free', 
          name: 'gbOptions3SSimFree',
          component: GbOptions3SSimFree 
        },
        { 
          path: '/gb/sim-included', 
          name: 'gbOptionsSimIncluded',
          component: GbOptionsSimIncluded 
        },
        { 
          path: '/gb/technical-specifications', 
          name: 'gbTechnicalSpecifications',
          component: GbTechnicalSpecifications 
        },
        { 
          path: '/us', 
          name: 'usProduct',
          component: UsProduct 
        },
        { 
          path: '/us/x5',
          name: 'usOptionsX5',
          component: UsOptionsX5
        },
        { 
          path: '/de', 
          name: 'deProduct',
          component: DeProduct 
        },
        { 
          path: '/de/sim-free', 
          name: 'deOptionsSimFree',
          component: DeOptionsSimFree 
        },
        { 
          path: '/de/x4', 
          name: 'deOptionsX4',
          component: DeOptionsX4
        },
        { 
          path: '/de/x5',
          name: 'deOptionsX5',
          component: DeOptionsX5
        },
        { 
          path: '/de/xgo2',
          name: 'deOptionsXGO2',
          component: DeOptionsXGO2
        },
        { 
          path: '/de/go-sim-free', 
          name: 'deOptionsGoSimFree',
          component: DeOptionsGoSimFree
        },
        { 
          path: '/de/3s-sim-free', 
          name: 'deOptions3SSimFree',
          component: DeOptions3SSimFree 
        },
        { 
          path: '/de/3-sim-free', 
          name: 'deOptions3SimFree',
          component: DeOptions3SimFree 
        },
        {
          path: '/de/activity-band', 
          name: 'deOptionsActivityBand',
          component: DeOptionsActivityBand 
        },
        { 
          path: '/de/sim-included', 
          name: 'deOptionsSimIncluded',
          component: DeOptionsSimIncluded 
        },
        { 
          path: '/de/technical-specifications', 
          name: 'deTechnicalSpecifications',
          component: DeTechnicalSpecifications 
        },

        {
          path: '/es', 
          name: 'esProduct',
          component: EsProduct 
        },
        { 
          path: '/es/x1', 
          name: 'esOptionsSimFree',
          component: EsOptionsSimFree 
        },
        {
          path: '/es/x3s',
          name: 'esOptions3SSimFree',
          component: EsOptions3SSimFree
        },
        {
          path: '/es/go',
          name: 'esOptionsGoSimFree',
          component: EsOptionsGoSimFree
        },
        {
          path: '/es/x4',
          name: 'esOptionsX4',
          component: EsOptionsX4
        },
        {
          path: '/es/x5',
          name: 'esOptionsX5',
          component: EsOptionsX5
        },
        {
          path: '/es/xgo2',
          name: 'esOptionsXGO2',
          component: EsOptionsXGO2
        },
        { 
          path: '/es/technical-specifications', 
          name: 'esTechnicalSpecifications',
          component: EsTechnicalSpecifications 
        },

        {
          path: '/fr', 
          name: 'frProduct',
          component: FrProduct 
        },
        {
          path: '/fr/x3s',
          name: 'frOptions3SSimFree',
          component: FrOptions3SSimFree
        },

        { 
          path: '/pl', 
          name: 'plOptionsSimFree',
          component: PlOptionsSimFree 
        },
        { 
          path: '/pl/technical-specifications', 
          name: 'plTechnicalSpecifications',
          component: PlTechnicalSpecifications 
        },

        { 
          path: '/no', 
          name: 'noProduct',
          component: NoProduct 
        },
        { 
          path: '/no/xplora1', 
          name: 'noOptionsXplora1',
          component: NoOptionsXplora1 
        },
        { 
          path: '/no/xplora2', 
          name: 'noOptionsXplora2',
          component: NoOptionsXplora2
        },
        { 
          path: '/no/xplora3s', 
          name: 'noOptionsXplora3S',
          component: NoOptionsXplora3S 
        },
        { 
          path: '/no/xplorago', 
          name: 'noOptionsXploraGo',
          component: NoOptionsXploraGo
        },

        { 
          path: '/se', 
          name: 'seProduct',
          component: SeProduct 
        },
        { 
          path: '/se/xplora1', 
          name: 'seOptionsXplora1',
          component: SeOptionsXplora1 
        },
        { 
          path: '/se/xplora2', 
          name: 'seOptionsXplora2',
          component: SeOptionsXplora2
        },
        { 
          path: '/se/xplora3s', 
          name: 'seOptionsXplora3S',
          component: SeOptionsXplora3S 
        },
        { 
          path: '/hu/information', 
          name: 'huInformation',
          component: HungaryInformation 
        },
        
    ],
    scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
  });


  Vue.use(VueAnalytics, {
    id: 'UA-101937080-8',
    checkDuplicatedScript: true,
    ecommerce: {
      enabled: true,
      //enhanced: true
    },
    router
  });

  return router;
}


// WEBPACK FOOTER //
// ./src/router/router.js